import { createContext, ReactNode, useMemo } from "react";
import { useQuery } from "react-query";
import { getSegment } from "../services/company";

type CompanySegmentProviderProps = {
  children: ReactNode;
};

export type CompanySegmentContextData = {
  id: number;
  segment: number;
  isLoading: boolean;
};

export const CompanySegmentContext =
  createContext<CompanySegmentContextData | null>(
    {} as CompanySegmentContextData
  );

export function CompanySegmentProvider({
  children,
}: CompanySegmentProviderProps) {
  const { data, isLoading } = useQuery(
    "getCompanySegment",
    async () => {
      const response = await getSegment();

      console.log("response - provider", response);

      return response;
    },
    {
      onError: (err: any) => {
        console.log(`err company segment provider request: ${err}`);
      },
    }
  );

  const factoryCompanySegmentData = useMemo(() => {
    if (!data) {
      return null;
    }

    return {
      ...data?.data.content,
      isLoading,
    };
  }, [data, isLoading]);

  console.log("factoryCompanySegmentData", factoryCompanySegmentData);

  return (
    <CompanySegmentContext.Provider value={factoryCompanySegmentData}>
      {children}
    </CompanySegmentContext.Provider>
  );
}
